import type {
    GetCommerceProductRequest,
    GetCommerceProductResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceProductOperation = defineCommerceOperation<
    GetCommerceProductRequest,
    GetCommerceProductResponse
>("commerce.products.get");
